import { Resources } from 'constants/resources';

import { queryClient } from 'providers/queryClient';
import { useDelete } from 'react-admin';
import { Button, CancelButton } from 'shared/mui/Buttons';
import { BaseDialog, DialogProps } from 'shared/mui/Dialogs';

type Props = {
  disputeId: string;
} & DialogProps;

export const OrdersShowDisputesDeleteDialog: React.FC<Props> = ({ disputeId, onClose, open }) => {
  const [deleteOne] = useDelete(
    'order_disputes',
    {
      id: disputeId,
    },
    { onSuccess: () => queryClient.refetchQueries({ queryKey: [Resources.Orders, 'getOne'] }) },
  );

  return (
    <BaseDialog
      message="Подтвердите удаление диспута"
      onClose={onClose}
      open={open}
      rightActionsSlot={[
        <CancelButton key="cancel-button" label="Отменить" onClick={onClose} variant="outlined" />,
        <Button
          color="error"
          key="delete-button"
          label="Подтвердить"
          onClick={() => {
            deleteOne();
            onClose();
          }}
          variant="contained"
        />,
      ]}
      title="Удаление диспута"
    />
  );
};
